import PoolsApi from '../api/pools'

export const DELIVERYHOURS_GOTO_EDIT_MODE = 'deliveryHours/DELIVERYHOURS_GOTO_EDIT_MODE'

export const DELIVERYHOURS_UPDATE_EDIT = 'deliveryhours/DELIVERYHOURS_UPDATE_EDIT'

export const LOAD_DELIVERYHOURS_REQUESTED = 'deliveryhours/LOAD_DELIVERYHOURS_REQUESTED'
export const LOAD_DELIVERYHOURS_LOADED = 'deliveryhours/LOAD_DELIVERYHOURS_LOADED'
export const LOAD_DELIVERYHOURS_ERROR = 'deliveryhours/LOAD_DELIVERYHOURS_ERROR'

export const SAVE_DELIVERYHOURS_REQUESTED = 'deliveryhours/SAVE_DELIVERYHOURS_REQUESTED'
export const SAVE_DELIVERYHOURS_LOADED = 'deliveryhours/SAVE_DELIVERYHOURS_LOADED'
export const SAVE_DELIVERYHOURS_ERROR = 'deliveryhours/SAVE_DELIVERYHOURS_ERROR'

const GENERIC_SAVE_FAIL_API_ERROR_MESSAGE = 'Could not save data. Please try again later.'

export const gotoEditMode = (editMode) => {
  return dispatch => dispatch({
    type: DELIVERYHOURS_GOTO_EDIT_MODE,
    editMode: editMode
  })
}

export const updateEditDeliveryHours = (deliveryHours) => {
  return dispatch => dispatch({
    type: DELIVERYHOURS_UPDATE_EDIT,
    editDeliveryHours: deliveryHours
  })
}

export const loadDeliveryHoursAsync = (poolId) => {
  return dispatch => {
    dispatch({
      type: LOAD_DELIVERYHOURS_REQUESTED,
      poolId: poolId
    })

    return PoolsApi.GetDeliveryHours(poolId)
      .then(response => {
        return response.json()
      })
      .then(json => dispatch({
        type: LOAD_DELIVERYHOURS_LOADED,
        data: json
      }))
      .catch(error => {
        dispatch({
          type: LOAD_DELIVERYHOURS_ERROR,
          error: error.message 
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}

export const saveDeliveryHoursAsync = (poolId, newDeliveryHours) => {
  return dispatch => {
    dispatch({
      type: SAVE_DELIVERYHOURS_REQUESTED,
      poolId: poolId,
      deliveryHours: newDeliveryHours
    })

    return PoolsApi.SaveDeliveryHours(poolId, newDeliveryHours)
      .then(response => {
        if (response.ok) {
          return dispatch({
            poolId: poolId,
            type: SAVE_DELIVERYHOURS_LOADED,
            data: newDeliveryHours
          })
        } else {
          return response.text()
            .then(errorMessage => {
              throw new Error(errorMessage)
            })
        }
      })
      .catch(error => {
        dispatch({
          type: SAVE_DELIVERYHOURS_ERROR,
          error: error.message || GENERIC_SAVE_FAIL_API_ERROR_MESSAGE
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/deliveryHours.js